import { createContext } from "react";

export interface FontSizeContextValue {
  baseFontSize: number;
  setBaseFontSize: (size: number) => void;
}

export const FontSizeContext = createContext<FontSizeContextValue | undefined>(
  undefined
);
